/**
 * Carousel End Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initCarouselEnd() {
        const blocks = document.querySelectorAll('.carousel-end');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] carousel-end block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCarouselEnd);
    } else {
        initCarouselEnd();
    }
})();